<template>

    <div class="teamStatsSmall">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap mb-3">
            <div class="statsCardLabel mr-md-4">
                <p class="stats-card-header">{{ translations.player }}</p>
                <div class="selectDiv">
                    <select v-model="selectedPlayer" style="width: 100%; border-radius: 10px; padding: 8px 16px; border: 1px solid rgba(51, 51, 51, 0.25);">
                        <option v-for="(player) in playerStats.teamStatistics[currentSeason].playerStatistics"  :value="player.playerName">
                            {{ player.playerName }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="statsCardLabel">
                <p class="stats-card-header">{{ translations.season }}</p>
                <div class="selectDiv">
                    <select v-model="currentSeason" @change="changeSeason" style="width: 100%; border-radius: 10px; padding: 8px 16px; border: 1px solid rgba(51, 51, 51, 0.25);">
                        <option v-for="(season) in playerStats.teamStatistics" :value="season.id">
                            20{{ season.season.seasonYear.split("/")[0] }}/20{{ season.season.seasonYear.split("/")[1] }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between flex-wrap flex-lg-nowrap">
            <div class="statsCard d-flex justify-content-between mr-md-4">
                <div class="stats-card-header">{{ translations.goals }}</div><div class="stats-card-header" :key="goalsScored">{{ goalsScored }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between mr-lg-4">
                <div class="stats-card-header">{{ translations.assists }}</div><div class="stats-card-header" :key="assists">{{ assists }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between mr-md-4">
                <div class="stats-card-header">{{ translations.substitutions }}</div><div class="stats-card-header" :key="substitutions">{{ substitutions }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between">
                <div class="stats-card-header">{{ translations.matches_played }}</div><div class="stats-card-header" :key="matchesPlayed">{{ matchesPlayed }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'player-stats',
    props: {
        playerStats: {
            type: Object,
            required: true,
        }, 
        translations: {
            type: Object,
            required: true,
        },

    },
    data: function () {
        return {
            currentSeason: this.playerStats.currentSeason.id,
            selectedPlayer: this.playerStats.teamStatistics[this.playerStats.currentSeason.id].currentPlayer,
        }
       
    },
    methods: {
        changeSeason() {

            if(!this.playerStats.teamStatistics[this.currentSeason].playerStatistics[this.selectedPlayer]) {
                console.log("player not found, using default")
                this.selectedPlayer = this.playerStats.teamStatistics[this.currentSeason].currentPlayer;
            } 
        },

    },
    computed: {
        goalsScored() {
            return this.playerStats.teamStatistics[this.currentSeason].playerStatistics[this.selectedPlayer].goals_scored
        },
        assists() {
            return this.playerStats.teamStatistics[this.currentSeason].playerStatistics[this.selectedPlayer].assists
        },
        substitutions() {
            return this.playerStats.teamStatistics[this.currentSeason].playerStatistics[this.selectedPlayer].substituted_out
        },
        matchesPlayed() {
            return this.playerStats.teamStatistics[this.currentSeason].playerStatistics[this.selectedPlayer].matches_played
        }
    },
    mounted: function () {

    },
}

</script>